<div class="form-group">
  <label [for]="id">
    {{ label }}<span *ngIf="showColonAfterLabel">:</span><span *ngIf="requiredMark" class="required-mark mr-2">*</span>
    <app-info-popover *ngIf="info" [content]="info"></app-info-popover>
  </label>

  <ng-container *ngIf="!range; else rangeDate">
    <input
      type="text"
      class="form-control calendar-field"
      [bsConfig]="bsConfig"
      [formControl]="dateControl"
      [maxDate]="maxDate"
      [minDate]="minDate"
      [placeholder]="placeholder"
      bsDatepicker
      (keydown)="onUserKeyDown($event)"
      (input)="onUserType($event)"
      autocomplete="off"
      required
      [id]="id"
    />
  </ng-container>
</div>

<ng-template #rangeDate>
  <input
    [placeholder]="placeholder || 'Desde / Hasta'"
    type="text"
    class="calendar-field form-control d-none d-sm-block"
    [bsConfig]="bsConfig"
    [maxDate]="maxDate"
    [minDate]="minDate"
    [formControl]="dateControl"
    bsDaterangepicker
    autocomplete="off"
    required
    [id]="id"
  />

  <div class="row d-block d-sm-none">
    <div class="col-md-6">
      <div class="form-group">
        <input
          type="text"
          class="form-control calendar-field"
          [bsConfig]="bsConfig"
          [minDate]="minDate"
          placeholder="Desde"
          bsDatepicker
          autocomplete="off"
          [maxDate]="rangeEndDate || maxDate"
          [(ngModel)]="rangeStartDate"
          (ngModelChange)="onChangeStartDate($event)"
          [id]="id"
        />
      </div>
    </div>
    <div class="col-md-6">
      <div class="form-group">
        <input
          type="text"
          class="form-control calendar-field"
          [bsConfig]="bsConfig"
          [maxDate]="maxDate"
          [minDate]="rangeStartDate"
          placeholder="Hasta"
          bsDatepicker
          autocomplete="off"
          [(ngModel)]="rangeEndDate"
          (ngModelChange)="onChangeEndDate($event)"
        />
      </div>
    </div>
  </div>
</ng-template>
